import React, { useEffect } from 'react';
import { useLocation, useNavigate, useRouteError } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/error', { state: { error: error } });
  }, [location]);
  return <div></div>;
}
